import { render, staticRenderFns } from "./LMS.vue?vue&type=template&id=58c97d8d&scoped=true&lang=html"
import script from "./LMS.vue?vue&type=script&lang=js"
export * from "./LMS.vue?vue&type=script&lang=js"
import style0 from "./LMS.vue?vue&type=style&index=0&id=58c97d8d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c97d8d",
  null
  
)

export default component.exports